import RenovationItemsEnum from "rules/enums/renovation/renovation-items.enum"



interface IRenovationItems {
    key: RenovationItemsEnum
    label: string
}

const renovationItems: IRenovationItems[] = [
    {
        key: "CABINET_COMMODE",
        label: "کابینت و کمد"
    },
    {
        key: "FACILITIES",
        label: "تاسیسات"
    },
    {
        key: "KENUF",
        label: "کناف"
    },
    {
        key: "PAINT_WALLPAPER",
        label: "نقاشی و کاغذ دیواری"
    }
]

export const renovationConstant = {
    name: "renovationItems",
    title: "چه مواردی برای بازسازی مدنظرتون هست؟",
    mode: "check",
    items: renovationItems
}